import React from 'react';

/**
 * React context for global variables. In browser, it's just means props o f
 * `window`;
 */
const GlobalContext = React.createContext<any>({});
export default GlobalContext;
